var style = {"z-loading-icon":"z-loading-icon","z-loading-icon--spinner":"z-loading-icon--spinner","z-anim-loading-icon-rotate":"z-anim-loading-icon-rotate","z-loading-icon--paw":"z-loading-icon--paw","z-anim-loading-icon-bounce-in-up":"z-anim-loading-icon-bounce-in-up","z-anim-loading-icon-toes-fade-in":"z-anim-loading-icon-toes-fade-in"};

export { style as default };
//# sourceMappingURL=LoadingIcon.module.scss.js.map
